import React from 'react';
import LiveProgramsListingPage from './LiveProgramsListingPage';
export default function LiveWorkshopsPage() { return <LiveProgramsListingPage type="workshop"/>; }
